import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M9.24 19H21v2H3v-4.24l9.9-9.9 4.24 4.24-7.9 7.9z"/>
    <path fill="#34CEFF" d="M16.43 3.32l-2.12 2.12 4.25 4.25 2.12-2.12a1 1 0 000-1.42l-2.83-2.83a1 1 0 00-1.42 0z"/>
  </SvgIcon>
);